import { useMutation } from "@apollo/client";
import { DELETE_WANTED_ITEM } from "../wantedItemTypeDefs";

export const useMutationDeleteWantedItem = (options?: any): any => (
  useMutation(DELETE_WANTED_ITEM, options)
);
